<script>
  import { cn } from '$lib/utils/misc';

  export let warning = false;
</script>

<div
  class={cn('text-gray-dark-6 flex-1 overflow-hidden', $$props.class, {
    'text-orange-dark-11': warning,
  })}
>
  <span class="">░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░</span>
</div>
